import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-create-consultant',
  templateUrl: './modal-create-consultant.component.html',
  styleUrls: ['./modal-create-consultant.component.css']
})
export class ModalCreateConsultantComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalCreateConsultantComponent>
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
